function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getLanguage } from 'shared/helper/link-helper';
import { storage } from 'shared/helper/storage';
import { checkChinaUsers } from 'shared/helper/request';
import featureEnabled from 'shared/helper/feature';
window.dataLayer = window.dataLayer || [];
var getUTM = function getUTM(param) {
  try {
    return new URLSearchParams(window.location.search).get(param) || '';
  } catch (e) {
    return '';
  }
};
var UTM_DATA = {
  utm_source: getUTM('utm_source'),
  utm_medium: getUTM('utm_medium'),
  utm_campaign: getUTM('utm_campaign'),
  utm_term: getUTM('utm_term'),
  utm_content: getUTM('utm_content')
};
window.dataLayer.push(_objectSpread({
  event: 'utm_loaded'
}, UTM_DATA));
var getRegionalInfo = function getRegionalInfo() {
  var isChinaUser = checkChinaUsers(); // Determine if China user based on URL

  return {
    site_region: isChinaUser ? 'China' : 'ROW',
    site_country_code: isChinaUser ? 'CN' : '',
    site_language: getLanguage()
  };
};
var pushEvent = function pushEvent(eventName) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var regionalContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  window.dataLayer.push(_objectSpread(_objectSpread(_objectSpread({
    event: eventName
  }, UTM_DATA), getRegionalInfo(regionalContext)), extraData));
};
export var recordUrl = function recordUrl(url) {
  var restrictLanguages = featureEnabled('rubriq_restrict_languages');
  var languageRegex = restrictLanguages ? /(cn|en)\// : /(cn|jp|en|br|es)\//;
  var urlWithoutLanguage = url.replace(languageRegex, '');

  // For urls like /researcher, log it as /en/researcher to ensure the language arrives.
  window.dataLayer.push({
    AdjustedLanguageURL: "/".concat(getLanguage(url)).concat(urlWithoutLanguage)
  });
};
export var recordUser = function recordUser(user) {
  if (user) {
    window.dataLayer.push({
      Authenticated: 'Logged In'
    });
    window.dataLayer.push({
      UUID: user.gtmUid
    });
    window.dataLayer.push({
      RSUID: user.id
    });
    window.dataLayer.push({
      customerId: user.identity
    });
    window.dataLayer.push({
      dlCustomerId: user.identity
    });
    window.dataLayer.push({
      userEmail: user.email
    });
  } else {
    window.dataLayer.push({
      Authenticated: 'Not Logged In'
    });
  }
};
export var recordNumberOfOrders = function recordNumberOfOrders(numberOfOrders) {
  window.dataLayer.push({
    Subs: numberOfOrders
  });
};
export var recordTransaction = function recordTransaction(_ref) {
  var identifier = _ref.identifier,
    total = _ref.total,
    products = _ref.products,
    affiliation = _ref.affiliation;
  // We _only_ want to emit this set of events once per session
  var storageKey = "recordDigitalServicesTransaction".concat(identifier);
  if (storage.get(storageKey)) {
    return;
  }
  window.dataLayer.push({
    event: 'trackTrans',
    dlTransactionId: identifier,
    dlTransactionTotal: total,
    // These are used via GA ecommerce. See https://support.google.com/tagmanager/answer/6107169
    transactionId: identifier,
    transactionTotal: total,
    transactionProducts: products,
    transactionAffiliation: affiliation // companyShortName
  });
};
export var recordOrderCompletion = function recordOrderCompletion(order) {
  if (!order) {
    return;
  }

  // We _only_ want to emit this set of events once per session
  var storageKey = "recordOrderCompletion".concat(order.externalId);
  if (storage.get(storageKey)) {
    return;
  }
  var items = order.items,
    products = order.products,
    skus = order.skus;
  recordTransaction({
    identifier: order.externalId,
    products: items || [],
    total: order.usdAmount,
    affiliation: order.user.companyShortName
  });
  window.dataLayer.push({
    event: 'submission-complete',
    dlCurrency: 'USD',
    dlCustomerId: order.user.identity,
    dlOrderId: order.receiptCode,
    dlRevenue: order.usdAmount,
    dlTransactionId: order.externalId,
    // These variables don't appear to be used by GTM
    dlProducts: products || '',
    // list of service names (separated by |)
    dlSkus: skus || '',
    // list of service skus (separated by |)
    dlAos: order.areaOfStudy,
    dlDiscount: order.discountAmount,
    dlCouponCodes: order.promotionalCodes,
    // promotional codes (separated by |)
    dlCity: order.invoiceAddress.city || '',
    dlState: order.invoiceAddress.state || '',
    dlZip: order.invoiceAddress.zip || '',
    dlCountry: order.invoiceAddress.countryIso || ''
  });
  storage.set(storageKey, true);
};
export var recordWordCountNoticeInteraction = function recordWordCountNoticeInteraction(wordCountChangedManually, userIdentity) {
  var userChangedWordBin = wordCountChangedManually ? 'changed' : 'ignored';
  window.dataLayer.push({
    event: 'wordCountResponse',
    dlCustomerId: userIdentity,
    wordCountChanged: userChangedWordBin
  });
};
var recordGenericEvent = function recordGenericEvent(_ref2) {
  var eventCategory = _ref2.eventCategory,
    eventAction = _ref2.eventAction,
    eventLabel = _ref2.eventLabel;
  return window.dataLayer.push({
    event: 'analyticsEvent',
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  });
};
export var recordSkipUploadFirstEvent = function recordSkipUploadFirstEvent(eventLabel) {
  return recordGenericEvent({
    eventAction: 'Skip upload-first',
    eventCategory: 'Selection',
    eventLabel: eventLabel
  });
};
export var recordLanguageAssessmentScoreCompletion = function recordLanguageAssessmentScoreCompletion() {
  return window.dataLayer.push({
    event: 'grammarCheckResultAvailable'
  });
};
export var recordSignInClick = function recordSignInClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$buttonText = _ref3.buttonText,
    buttonText = _ref3$buttonText === void 0 ? 'Sign-in' : _ref3$buttonText;
  pushEvent('sign_in_click', {
    button_id: 'login_button',
    button_text: buttonText
  });
};
export var recordStartFreeTrialClick = function recordStartFreeTrialClick() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$buttonText = _ref4.buttonText,
    buttonText = _ref4$buttonText === void 0 ? 'Start Free Trial' : _ref4$buttonText;
  pushEvent('start_free_trial_click', {
    button_id: 'start_free_trial_btn',
    button_text: buttonText
  });
};
export var recordServiceSelected = function recordServiceSelected(_ref5) {
  var _ref5$buttonId = _ref5.buttonId,
    buttonId = _ref5$buttonId === void 0 ? '' : _ref5$buttonId,
    productName = _ref5.productName;
  pushEvent('service_selected_trial_7day', {
    button_id: buttonId,
    product_name: productName
  });
};
export var recordFreeTrialPurchaseInitiated = function recordFreeTrialPurchaseInitiated() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$buttonText = _ref6.buttonText,
    buttonText = _ref6$buttonText === void 0 ? 'Start your free trial' : _ref6$buttonText,
    _ref6$productName = _ref6.productName,
    productName = _ref6$productName === void 0 ? '' : _ref6$productName,
    _ref6$finalAmount = _ref6.finalAmount,
    finalAmount = _ref6$finalAmount === void 0 ? '' : _ref6$finalAmount,
    _ref6$currency = _ref6.currency,
    currency = _ref6$currency === void 0 ? '' : _ref6$currency;
  pushEvent('free_trial_purchase_initiated', {
    button_id: 'start_free_trial_payment_btn',
    button_text: buttonText,
    product_name: productName,
    final_amount: finalAmount,
    currency: currency
  });
};
export var recordStart14DayTrialClick = function recordStart14DayTrialClick() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$buttonId = _ref7.buttonId,
    buttonId = _ref7$buttonId === void 0 ? '' : _ref7$buttonId,
    _ref7$productName = _ref7.productName,
    productName = _ref7$productName === void 0 ? '' : _ref7$productName,
    _ref7$displayedPrice = _ref7.displayedPrice,
    displayedPrice = _ref7$displayedPrice === void 0 ? '' : _ref7$displayedPrice;
  pushEvent('start_14day_free_trial_click', {
    button_id: buttonId,
    product_name: productName,
    displayed_price: displayedPrice,
    currency: 'CNY'
  });
};
export var recordTrialContractConfirmed = function recordTrialContractConfirmed() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref8$productName = _ref8.productName,
    productName = _ref8$productName === void 0 ? '' : _ref8$productName,
    _ref8$finalAmount = _ref8.finalAmount,
    finalAmount = _ref8$finalAmount === void 0 ? '' : _ref8$finalAmount;
  pushEvent('trial_contract_confirmed', {
    button_id: 'keep_payment_btn_cn',
    product_name: productName,
    plan_term: 'Yearly',
    final_amount: finalAmount,
    currency: 'CNY'
  });
};
export var recordAgreeAndSignUp = function recordAgreeAndSignUp() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$buttonText = _ref9.buttonText,
    buttonText = _ref9$buttonText === void 0 ? 'Agree and Sign up' : _ref9$buttonText;
  pushEvent('agree_sign_up_click', {
    button_id: 'agree_and_signup_button',
    button_text: buttonText
  });
};
export var recordUpgradeNowClick = function recordUpgradeNowClick() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$buttonText = _ref10.buttonText,
    buttonText = _ref10$buttonText === void 0 ? 'Upgrade Now' : _ref10$buttonText;
  pushEvent('start_free_trial_click', {
    button_id: 'upgrade_now_free_trial_btn',
    button_text: buttonText
  });
};
export var recordTryForFreeClick = function recordTryForFreeClick() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref11$buttonText = _ref11.buttonText,
    buttonText = _ref11$buttonText === void 0 ? 'Try for free' : _ref11$buttonText;
  pushEvent('start_free_trial_click', {
    button_id: 'upgrade_try_for_free_trial_btn',
    button_text: buttonText
  });
};
export var recordPurchaseComplete = function recordPurchaseComplete() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref12$transactionId = _ref12.transactionId,
    transactionId = _ref12$transactionId === void 0 ? '' : _ref12$transactionId,
    _ref12$orderId = _ref12.orderId,
    orderId = _ref12$orderId === void 0 ? '' : _ref12$orderId,
    _ref12$revenue = _ref12.revenue,
    revenue = _ref12$revenue === void 0 ? 0 : _ref12$revenue,
    _ref12$currency = _ref12.currency,
    currency = _ref12$currency === void 0 ? '' : _ref12$currency,
    _ref12$productName = _ref12.productName,
    productName = _ref12$productName === void 0 ? '' : _ref12$productName,
    _ref12$planTerm = _ref12.planTerm,
    planTerm = _ref12$planTerm === void 0 ? '' : _ref12$planTerm,
    _ref12$paymentMode = _ref12.paymentMode,
    paymentMode = _ref12$paymentMode === void 0 ? '' : _ref12$paymentMode;
  pushEvent('purchase', {
    transaction_id: transactionId,
    order_id: orderId,
    value: revenue,
    currency: currency,
    payment_mode: paymentMode,
    plan_opted: productName,
    plan_term: planTerm
  });
};